import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { store } from './dashboard/store/store';
import { theme } from './dashboard/constants/themes/theme';
import './dashboard/index.scss';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { initSlackTracking } from "./dashboard/utils/slackErrorNotifier";
import ErrorBoundary from './dashboard/components/common/ErrorBoundary/ErrorBoundary';
import { lazyRetry } from './dashboard/utils/lazyRetry';
import { setupGlobalChunkErrorHandler } from './dashboard/utils/chunkLoadRecovery';



import MicLoader from './dashboard/components/ui/Loaders/MicLoader';

const DashboardApp = React.lazy(() => lazyRetry(() => import('./dashboard/App')));
const DashboardLogin = React.lazy(() => lazyRetry(() => import('./dashboard/pages/Auth/Login/Login')));





Sentry.init({

  dsn: process.env.REACT_APP_SENTRY_DSN,
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],


  tracesSampleRate: 1.0,




});
Sentry.setTag("app", "Admin");

initSlackTracking();
setupGlobalChunkErrorHandler();


const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(

  <ErrorBoundary>
    <React.Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><MicLoader /></div>}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={
            <Provider store={store}>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <DashboardLogin />
              </ThemeProvider>
            </Provider>
          } />
          <Route path="/admin/*" element={
            <Provider store={store}>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <DashboardApp />
              </ThemeProvider>
            </Provider>
          } />
          <Route path="/super-admin/*" element={
            <Provider store={store}>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <DashboardApp />
              </ThemeProvider>
            </Provider>
          } />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </React.Suspense>
  </ErrorBoundary>

);